import { Component } from 'preact';
import StringWrapper from "../../../util/wrapper/StringWrapper";
import OpeningHoursContainer from "../../opening-hours/OpeningHoursContainer";
import { CARRIER_LOGO_URL } from "../../../constants/constants";
import ClassNames from "classnames";
import { isStoreOption } from "../../../util/AppUtils";
import { doGet } from "../../../util/NetworkUtils";

export default class MapMarker extends Component {

    constructor(props) {
        super(props);
        let opened = props.pickupLocation && props.pickupLocation.checked;
        this.state = {
            opened: opened,
            imageAvailable: true,
            carrierLogoImage: ''
        };
        if (opened) {
            this.scrollToPickupLocation();
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('touchstart', this.handleClickOutside);
        }
    }

    componentDidMount() {
        const {pickupLocation, config} = this.props;
        if (this.state.opened) {
            this.props.updateMapPosition();
        }

        this.loadCarrierLogo(CARRIER_LOGO_URL + pickupLocation.shippingOptions[0].carrier.name + ".svg", config);
    }

    loadCarrierLogo = (logoUrl, config) => {
        doGet(logoUrl, config)
            .then(res => {
                this.setState({
                    carrierLogoImage: !res || !res.data ? "" : `data:image/svg+xml;base64,${res.data}`,
                    imageAvailable: true
                });
            })
            .catch(err => {
                console.error(err);

                this.setState({
                    carrierLogoImage: ""
                });
            });
    };

    componentDidUpdate(prevProps, prevState) {
        const {updateMapPosition, pickupLocation} = this.props;
        const {opened} = this.state;

        if (opened && !prevState.opened) {
            updateMapPosition();
        }

        if (!prevProps.pickupLocation.checked && pickupLocation.checked) {
            updateMapPosition();
            this.setState({
                opened: true,
                animated: !this.props.animationPaused
            });
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('touchstart', this.handleClickOutside);
        }

        if (prevProps.pickupLocation.checked && !pickupLocation.checked) {
            this.setState({
                opened: false,
                animated: false
            });
        }

        if (prevProps.pickupLocation.checked && pickupLocation.checked && (prevProps.pickupLocation.code !== pickupLocation.code)) {
            this.setState({
                opened: true,
                animated: !this.props.animationPaused
            });
        }
    }

    onMarkerClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            opened: true
        });

        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchstart', this.handleClickOutside);
        this.props.onSelectPickupLocation(this.props.pickupLocation.code);
        this.scrollToPickupLocation();
    };

    scrollToPickupLocation = () => {
        const {pickupLocation} = this.props;
        pickupLocation && pickupLocation.ref && pickupLocation.ref.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    };

    onMarkerTouch = (e) => {
        e.stopPropagation();
    };

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };

    handleClickOutside = (event) => {
        const {pickupLocation} = this.props;

        let outsideTooltip = !this.wrapperRef || !this.wrapperRef.contains(event.target);
        let outsideListElement = !pickupLocation.ref || !pickupLocation.ref.contains(event.target);

        if (outsideTooltip && outsideListElement) {
            this.setState({
                opened: false,
                animated: false
            });

            document.removeEventListener('mousedown', this.handleClickOutside);
            document.removeEventListener('touchstart', this.handleClickOutside);
        }

    };

    getLogo = (isTooltipLogo) => {
        const {pickupLocation, isStorePickup, storeLogo} = this.props;
        const {carrierLogoImage} = this.state;

        if (isStorePickup || isStoreOption(pickupLocation)) {
            return storeLogo &&
                <img src={storeLogo}
                     className={isTooltipLogo ? 'tooltip__logo__source polyfill-object-fit-contain' : ''}
                     alt={"Store logo"}
                     onError={this.handleImageError}
                />;
        }
        return carrierLogoImage &&
            <img src={carrierLogoImage}
                 className={isTooltipLogo ? 'tooltip__logo__source polyfill-object-fit-contain': ''}
                 onError={this.handleImageError}
                 alt={pickupLocation.shippingOptions[0].carrier.name}
                 title={pickupLocation.shippingOptions[0].carrier.name}
            />;

    };

    handleImageError = () => {
        this.setState({
            imageAvailable: false
        });
    };

    render() {
        const {pickupLocation, storeLogo, setTooltipRef, config, animationPaused} = this.props;
        const {opened, imageAvailable, carrierLogoImage} = this.state;
        const openingTimes = pickupLocation.openingTimes;

        let addressLine = [pickupLocation.address.street, pickupLocation.address.streetNumber, pickupLocation.address.streetNumberSuffix].join(' ');

        const isStore = isStoreOption(pickupLocation);

        const isStoreLogoUsedAsMarker = isStore && storeLogo;
        const isCarrierLogoUsedAsMarker = !isStore && config.useCarrierLogoAsMapMarker && carrierLogoImage;
        const isDescriptionPresent = pickupLocation.description && pickupLocation.description.trim() !== '';

        return (
            <div ref={this.setWrapperRef} className="map-marker">
                {
                    opened &&
                    <div ref={setTooltipRef} className="widget-tooltip tooltip--map">
                        <div className="paazl-delimiter">
                            <header className="tooltip__header">
                                <hgroup className="tooltip__titles">
                                    <StringWrapper Tag="h4"
                                                   additionalClassName="tooltip__title"
                                                   content={pickupLocation.name}
                                                   notranslate/>
                                    {
                                        isDescriptionPresent &&
                                        <div className="tooltip__address"> {pickupLocation.description} </div>
                                    }

                                    <StringWrapper content={addressLine}
                                                   additionalClassName="tooltip__address"
                                                   notranslate/>

                                </hgroup>

                                <figure className="tooltip__logo">
                                    {
                                        imageAvailable && this.getLogo(true)
                                    }
                                </figure>
                            </header>

                            <OpeningHoursContainer openingTimes={openingTimes}/>
                        </div>
                    </div>
                }

                <div className="marker" onClick={this.onMarkerClick} onTouchStart={this.onMarkerTouch}>
                    <div className={ClassNames('pin', {
                        paused: animationPaused,
                        "image-marker": (isStoreLogoUsedAsMarker || isCarrierLogoUsedAsMarker) && imageAvailable,
                        "default-marker": (!isStoreLogoUsedAsMarker && !isCarrierLogoUsedAsMarker) || !imageAvailable,
                        'focused': pickupLocation.checked
                    })}>
                        {
                            (isStoreLogoUsedAsMarker || isCarrierLogoUsedAsMarker) &&
                            imageAvailable &&
                            this.getLogo(false)
                        }
                    </div>

                    <div className={ClassNames('pulse', {
                        'focused': pickupLocation.checked,
                        'paused': animationPaused
                    })}/>
                    
                </div>
            </div>
        );
    }
}